import { useQuery } from 'react-query';

import { QUERY_KEYS, Profile } from '@24i/nxg-sdk-photon/src';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';

import { useStore } from '../../context/ApplicationStore';

export const useProfilesQuery = () => {
    const client = useUserData();
    const { selectedProfile } = useStore();
    const profilesEnabled = useFeature('accounts')?.select_profiles || false;

    const { isLoading, data, refetch } = useQuery<Profile[]>(
        QUERY_KEYS.profiles,
        client.fetchUserProfiles,
        {
            enabled: profilesEnabled,
        }
    );

    return {
        isLoading,
        profiles: data,
        selectedProfile,
        refetch,
    };
};
